import styled from "@emotion/styled";

export const List = styled.ul`
  @media screen and (min-width: ${p => p.theme.screenSizes.lgMin}) {
    display: flex;
    gap: 20px;
  }
`;

export const Item = styled.li`
  :not(:last-child) {
    margin-bottom: 20px;
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.lgMin}) {
    margin-bottom: 0 !important;
  }
`;
